import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { totalRowRatio } from '../../../../../react-table/helpers/rowTotals';
import DirectionTypes from '../../../../../common/redux/actions/types/DirectionTypes';

export const getDetailsTabNavOptions = direction => rowInfo => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_901_DETAILS.id,
    mainReportId: ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_901_SUMMARY.id,
    requestParams: {
      carrier: rowInfo.row.carrier,
      direction,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {}
);

export const operatorInboundConditionalProps = (state, rowInfo) => {
  if (rowInfo) {
    const { row } = rowInfo;
    if (row.inboundOperator === null) {
      row.inboundOperator = '-';
    }
  }
  return {
  };
};

export const operatorOutboundConditionalProps = (state, rowInfo) => {
  if (rowInfo) {
    const { row } = rowInfo;
    if (row.outboundOperator === null) {
      row.outboundOperator = '-';
    }
  }
  return {
  };
};

export default (data) => {
  const {
    TextColumn,
    NonZeroPercentageColumn,
    NavigationWithFooterMultipleDrilldownOptionPercentageColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Carrier', 'carrier').withTotalHeader('Total').withWidth(180),
        new NonZeroPercentageColumn('Global score', 'globalScore').withTotalHeader(totalRowRatio(['globalScorePfVolume', 'globalScoreVolume'])).withWidth(180),
        new NonZeroPercentageColumn('', 'globalScorePfVolume').withShow(false),
        new NonZeroPercentageColumn('', 'globalScoreVolume').withShow(false),
        new NavigationWithFooterMultipleDrilldownOptionPercentageColumn(new NonZeroPercentageColumn('Operator inbound', 'inboundOperator').withGetProps(operatorInboundConditionalProps).withTotalHeader(totalRowRatio(['inboundOperatorPfVolume', 'inboundOperatorVolume'])).withWidth(180), getDetailsTabNavOptions(DirectionTypes.INBOUND)),
        new NonZeroPercentageColumn('', 'inboundOperatorPfVolume').withShow(false),
        new NonZeroPercentageColumn('', 'inboundOperatorVolume').withShow(false),
        new NavigationWithFooterMultipleDrilldownOptionPercentageColumn(new NonZeroPercentageColumn('Operator outbound', 'outboundOperator').withGetProps(operatorOutboundConditionalProps).withTotalHeader(totalRowRatio(['outboundOperatorPfVolume', 'outboundOperatorVolume'])).withWidth(180), getDetailsTabNavOptions(DirectionTypes.OUTBOUND)),
        new NonZeroPercentageColumn('', 'outboundOperatorPfVolume').withShow(false),
        new NonZeroPercentageColumn('', 'outboundOperatorVolume').withShow(false),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_901_DETAILS.id,
        mainReportId: ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_901_SUMMARY.id,
        requestParams: {
          isTotal: true,
          carrier: '*',
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
